// src/store/userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie'; // 引入 js-cookie
import { getUserProfile, getUserProfileByToken, login, login_new ,getCaptcha, verifyCaptcha, getSmsCaptcha } from '../api/user';
// 注意：需要导入 newLogin 方法，如果你还没有实现，可以先注释掉或补充实现
// import { newLogin } from '../api/user';

// 判断输入类型
const isPhoneNumber = (input) => /^\d{10,}$/.test(input);
const isEmail = (input) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);

export const fetchCaptcha = createAsyncThunk('user/fetchCaptcha', async (input, { rejectWithValue }) => {
  console.log('fetchCaptcha called with input:', input);
  try {
    let response;
    if (isPhoneNumber(input)) {
      response = await getSmsCaptcha(input); // 手机号调用短信验证码接口
    } else if (isEmail(input)) {
      response = await getCaptcha(input); // 邮箱调用原接口
    } else {
      return rejectWithValue('Invalid input: must be a valid email or phone number');
    }
    console.log('fetchCaptcha succeeded:', response);
    return response;
  } catch (err) {
    console.error('fetchCaptcha failed:', err.message);
    return rejectWithValue(err.message || 'Failed to fetch captcha');
  }
});

// 异步 Thunk：校验验证码
export const verifyCaptchaThunk = createAsyncThunk('user/verifyCaptcha', async ({ phoneNumbers, smsCode }, { rejectWithValue }) => {
  console.log('verifyCaptchaThunk called with phoneNumbers:', phoneNumbers, 'smsCode:', smsCode);
  try {
    const response = await verifyCaptcha({ phoneNumbers, smsCode });
    console.log('verifyCaptchaThunk succeeded:', response);
    return response;
  } catch (err) {
    console.error('verifyCaptchaThunk failed:', err.message);
    return rejectWithValue(err.message || 'Captcha verification failed');
  }
});

// 异步 Thunk：获取用户信息（基于 uid）
export const fetchUserProfile = createAsyncThunk('user/fetchUserProfile', async (_, { rejectWithValue }) => {
  console.log('fetchUserProfile called');
  const uid = localStorage.getItem('userId');
  if (!uid) {
    console.log('No uid found in localStorage');
    return rejectWithValue('No uid found in localStorage, user not logged in');
  }
  try {
    const response = await getUserProfile({ uid });
    if (!response || !response.data || !Array.isArray(response.data) || response.data.length === 0) {
      throw new Error('Invalid response format or empty user data');
    }
    console.log('fetchUserProfile succeeded:', response.data[0]);
    return response.data[0];
  } catch (err) {
    console.error('fetchUserProfile failed:', err.message);
    return rejectWithValue(err.message || 'Failed to fetch user profile');
  }
});

// 异步 Thunk：通过 url_login_token 获取用户信息
export const fetchUserProfileByToken = createAsyncThunk('user/fetchUserProfileByToken', async (url_login_token, { rejectWithValue }) => {
  console.log('Fetching with url_login_token:', url_login_token);
  if (!url_login_token) {
    return rejectWithValue('No token provided');
  }
  try {
    const response = await getUserProfileByToken({ url_login_token });
    console.log('API response:', response);
    const user = response.data;
    console.log('User data:', user);
    if (!user || typeof user !== 'object' || !user.uid) {
      throw new Error('Invalid user data: expected an object with uid');
    }
    localStorage.removeItem('userToken');
    localStorage.removeItem('uid');
    localStorage.removeItem('userId');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('user_key');
    console.log('logoutUser succeeded');
    localStorage.setItem('userId', user.uid);
    // 将 checkToken 写入 cookie，如果存在的话
    console.log('CheckToken saved to cookie:将 checkToken 写入 cookie，如果存在的话');
    console.log('CheckToken saved to cookie:将 checkToken 写入 cookie，如果存在的话'+ user);

    if (user.checkToken) {
      Cookies.set('checkToken', user.checkToken, { expires: 90 });
      console.log('CheckToken saved to cookie:', user.checkToken);
    }
    console.log('CheckToken saved to cookie:将 checkToken 写入 cookie，如果存在的话');
    console.log('CheckToken saved to cookie:将 checkToken 写入 cookie，如果存在的话');

    return user;
  } catch (err) {
    console.error('API error:', err.message);
    return rejectWithValue(err.message || 'Failed to fetch user profile by token');
  }
});

// 异步 Thunk：登录
export const loginUser = createAsyncThunk('user/login', async ({ uid }, { rejectWithValue }) => {
  console.log('loginUser called with uid:', uid);
  if (!uid) {
    return rejectWithValue('No uid provided for login');
  }
  try {
    const response = await login({ uid });
    if (!response || !response.data || !Array.isArray(response.data) || response.data.length === 0) {
      throw new Error('Invalid response format or empty user data');
    }
    localStorage.setItem('userId', uid);
    console.log('loginUser succeeded:', response.data[0]);
    return response.data[0];
  } catch (err) {
    console.error('loginUser failed:', err.message);
    return rejectWithValue(err.message || 'Login failed');
  }
});

// 新的异步 Thunk：新的登录方法
export const newLoginUser = createAsyncThunk('user/newLogin', async ({ uid }, { rejectWithValue }) => {
  console.log('newLoginUser called with uid:', uid);
  if (!uid) {
    return rejectWithValue('No uid provided for new login');
  }
  try {
    // 这里假设你有一个新的 API 方法 newLogin，需要从 ../api/user 导入
    // 如果尚未实现，可以临时使用 login 或自定义逻辑
    const response = await login_new({ uid }); // 临时复用 login，实际应替换为 newLogin
    // const response = await login_new({ uid }); // 取消注释并使用真实的 newLogin
    if (!response || !response.data || !Array.isArray(response.data) || response.data.length === 0) {
      throw new Error('Invalid response format or empty user data');
    }
    localStorage.setItem('userId', uid); // 保持与 loginUser 一致
    console.log('newLoginUser succeeded:', response.data[0]);
    return response.data[0];
  } catch (err) {
    console.error('newLoginUser failed:', err.message);
    return rejectWithValue(err.message || 'New login failed');
  }
});

// 异步 Thunk：退出登录
export const logoutUser = createAsyncThunk('user/logout', async (_, { dispatch }) => {
  console.log('logoutUser called');
  try {
    localStorage.removeItem('userToken');
    localStorage.removeItem('uid');
    localStorage.removeItem('userId');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('user_key');
    console.log('logoutUser succeeded');
    return null;
  } catch (err) {
    console.error('logoutUser failed:', err.message);
    throw err; // 让 Redux 处理错误
  }
});

const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    isLoggedIn: false,
    captcha: '',
    loading: false,
    error: '',
  },
  reducers: {
    clearError: (state) => {
      state.error = '';
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = !!action.payload;
      // 更新用户信息时存入 Cookie
      if (action.payload && action.payload.checkToken) {
        Cookies.set('checkToken', action.payload.checkToken, { expires: 90 });
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchCaptcha
      .addCase(fetchCaptcha.pending, (state) => {
        state.loading = true;
        state.error = '';
        console.log('fetchCaptcha pending');
      })
      .addCase(fetchCaptcha.fulfilled, (state, action) => {
        state.captcha = action.payload;
        state.loading = false;
        console.log('fetchCaptcha fulfilled:', action.payload);
      })
      .addCase(fetchCaptcha.rejected, (state, action) => {
        state.error = action.payload || 'Failed to fetch captcha';
        state.loading = false;
        console.log('fetchCaptcha rejected:', action.payload);
      })
      // verifyCaptchaThunk
      .addCase(verifyCaptchaThunk.pending, (state) => {
        state.loading = true;
        state.error = '';
        console.log('verifyCaptchaThunk pending');
      })
      .addCase(verifyCaptchaThunk.fulfilled, (state, action) => {
        state.loading = false;
        console.log('verifyCaptchaThunk fulfilled:', action.payload);
      })
      .addCase(verifyCaptchaThunk.rejected, (state, action) => {
        state.error = action.payload || 'Captcha verification failed';
        state.loading = false;
        console.log('verifyCaptchaThunk rejected:', action.payload);
      })
      // fetchUserProfile
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = '';
        console.log('fetchUserProfile pending');
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isLoggedIn = true;
        state.loading = false;
        // 将 checkToken 存入 Cookie
        if (action.payload && action.payload.checkToken) {
          Cookies.set('checkToken', action.payload.checkToken, { expires: 90 });
        }
        console.log('fetchUserProfile fulfilled:', state.user);
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.error = action.payload || 'Failed to fetch user profile';
        state.isLoggedIn = false;
        state.loading = false;
        console.log('fetchUserProfile rejected:', action.payload);
      })
      // fetchUserProfileByToken
      .addCase(fetchUserProfileByToken.pending, (state) => {
        state.loading = true;
        state.error = '';
        console.log('fetchUserProfileByToken pending');
      })
      .addCase(fetchUserProfileByToken.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isLoggedIn = true;
        state.loading = false;
        // 将 checkToken 存入 Cookie
        if (action.payload && action.payload.checkToken) {
          Cookies.set('checkToken', action.payload.checkToken, { expires: 90 });
        }
        console.log('fetchUserProfileByToken fulfilled:', state.user);
      })
      .addCase(fetchUserProfileByToken.rejected, (state, action) => {
        state.error = action.payload || 'Failed to fetch user profile by token';
        state.isLoggedIn = false;
        state.loading = false;
        console.log('fetchUserProfileByToken rejected:', action.payload);
      })
      // loginUser
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = '';
        console.log('loginUser pending');
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isLoggedIn = true;
        state.loading = false;
        // 将 checkToken 存入 Cookie
        if (action.payload && action.payload.checkToken) {
          Cookies.set('checkToken', action.payload.checkToken, { expires: 90 });
        }
        console.log('loginUser fulfilled:', state.user);
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.error = action.payload || 'Login failed';
        state.loading = false;
        console.log('loginUser rejected:', action.payload);
      })
      // newLoginUser
      .addCase(newLoginUser.pending, (state) => {
        state.loading = true;
        state.error = '';
        console.log('newLoginUser pending');
      })
      .addCase(newLoginUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isLoggedIn = true;
        state.loading = false;
        if (action.payload && action.payload.checkToken) {
          Cookies.set('checkToken', action.payload.checkToken, { expires: 90 });
        }
        console.log('newLoginUser fulfilled:', state.user);
      })
      .addCase(newLoginUser.rejected, (state, action) => {
        state.error = action.payload || 'New login failed';
        state.loading = false;
        console.log('newLoginUser rejected:', action.payload);
      })
      // logoutUser
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = '';
        console.log('logoutUser pending');
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.isLoggedIn = false;
        state.loading = false;
        Cookies.remove('checkToken'); // 退出登录时清除 Cookie
        console.log('logoutUser fulfilled');
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.error = action.payload || 'Logout failed';
        state.loading = false;
        console.log('logoutUser rejected:', action.payload);
      });
  },
});

export const { clearError, setUser } = userSlice.actions;
export default userSlice.reducer;